import type { HomePageCarouselItem } from '@bulknutrients/bulk-shared-lib/interfaces/ICarousel';
import type { getHomeVideoCTAs } from '@bulknutrients/bulk-shared-lib/lib/sanity/homePage';
import { SkeletonImage } from '@components/Placeholders/Skeleton';
import { HomePageCarousel } from './HomePageCarousel';
import { HomePageVideoCTA } from './HomePageVideoCTA';

export function HomePageCTA({
  carouselItems,
  homeVideoCTA,
}: {
  carouselItems: Array<HomePageCarouselItem>;
  homeVideoCTA: Awaited<ReturnType<typeof getHomeVideoCTAs>>;
}) {
  const cookieVariant = 0; //useCookieVariant('video-home-page-cta-june-2026');

  return cookieVariant === 0 ? (
    <HomePageCarousel carouselItems={carouselItems} />
  ) : cookieVariant === 1 ? (
    <HomePageVideoCTA homeVideoCTA={homeVideoCTA} />
  ) : (
    <SkeletonImage aspectRatio="aspect-square md:aspect-4/3 lg:aspect-1600/533" />
  );
}
